<template>
  <div id="app">
    <div class='formStep'>
      <div class='stepTitle'>Solicita tu campaña de Wapchita</div>
      <b-card>
        <b-form-group>
          <b-row>
            <b-col sm="3">
              <label class="required" :for="`mensaje`">Escribí tu mensaje acá o copiá y pegá un mensaje de whatsapp</label>
            </b-col>
            <b-col sm="9">
              <b-form-textarea
                autofocus
                :id="`mensaje`"
                v-model="mensaje"
                v-model.trim="mensaje"
                placeholder="Escribí acá un gran mensaje..."
                rows="3"
                max-rows="8"
                v-bind:class="{ 'is-invalid': errors.includes('mensaje') }"
              >
              </b-form-textarea>
              <div class="invalid-feedback">Campo obligatorio</div>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="3">
              <label class="required" :for="`fonodeprueba`">Agrega un número de whatsapp para hacer pruebas, podes hacer todas las pruebas que quieras</label>
            </b-col>
            <b-col sm="9">
              <b-form-input
                autofocus
                :id="`fonodeprueba`"
                v-model="fonodeprueba"
                v-model.trim="fonodeprueba"
                placeholder="Escribí el número al que quieras probar en formato internacional"
                type="number"
                v-bind:class="{ 'is-invalid': errors.includes('fonodeprueba') }"
              >
              </b-form-input>
              <div class="invalid-feedback">Campo obligatorio</div>
            </b-col>
          </b-row>
          <div class='buttonNavigation'>
            <b-button class='nextButton' @click="CheckForm()">Hacer prueba</b-button>
          </div>
          <b-row>
            <b-col sm="3">
              <label class="required" :for="`infobase`">Detallar a que base envia</label>
            </b-col>
            <b-col sm="9">
              <b-form-textarea
                autofocus
                :id="`infobase`"
                v-model="infobase"
                v-model.trim="infobase"
                placeholder="txt..."
                rows="3"
                max-rows="8"
                v-bind:class="{ 'is-invalid': errors.includes('infobase') }"
              >
              </b-form-textarea>
              <div class="invalid-feedback">Campo obligatorio</div>
            </b-col>
          </b-row>


          
          <div id="errores" class="disp-none">Tienes campo incompletos</div>
        </b-form-group>
      </b-card>
    </div>
    <div class='buttonNavigation'>
      <b-button class='nextButton' @click="CheckForm2()">Solicitar Envio</b-button>
    </div>
  </div>
</template>

<script>

const axios = require('axios').default;

axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
axios.defaults.headers.post['Access-Control-Allow-Methods'] = 'POST, OPTIONS';
axios.defaults.headers.post['Access-Control-Allow-Headers'] = 'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers,X-Access-Token,XKey,Authorization';

export default {
  props: [
    "accountType",
    'sessionId',
    'momentsSDK',
  ],
  data() {
    return {
      mensaje: '',
      fonodeprueba: '',
      infobase: '',
      errors: [],
    };
  },
  async created() {
  },
  methods: {
    async next1() {
        console.log(this.fonodeprueba);
      axios
		.post(
			"https://api.chat-api.com/instance182883/message?token=08wm1u3d1m2icrce",
			{
			phone: `${this.fonodeprueba}`,
			body: `${this.mensaje}`,
			}
		)
		.then((response) => {
		    console.log(response);
		})
		.catch((error) => {
			console.log(error);
		});
    },
    async next2() {
      axios
		.post(
			"https://api.chat-api.com/instance182883/message?token=08wm1u3d1m2icrce",
			{
			phone: `59895983155`,
			body: `Tienes una solicitud para sacar un envio a la *base*:
${this.infobase}

*Mensaje*:
${this.mensaje}`,
			}
		)
		.then((response) => {
		    console.log(response);
		})
		.catch((error) => {
			console.log(error);
		});
    },
    async CheckForm() {
      let divErr = document.getElementById("errores")
      this.errors = [];
      if (this.mensaje === '') {
        this.errors.push('mensaje');
        divErr.classList.remove("disp-none")
      }
      if (this.fonodeprueba === '') {
        this.errors.push('fonodeprueba');
        divErr.classList.remove("disp-none")
      }
      if (this.errors.length === 0) {
        divErr.classList.add("disp-none")
        this.next1();
      } 
    },
    async CheckForm2() {
      let divErr = document.getElementById("errores")
      this.errors = [];
      if (this.mensaje === '') {
        this.errors.push('mensaje');
        divErr.classList.remove("disp-none")
      }
      if (this.fonodeprueba === '') {
        this.errors.push('fonodeprueba');
        divErr.classList.remove("disp-none")
      }
      if (this.fonodeprueba === '') {
        this.errors.push('infobase');
        divErr.classList.remove("disp-none")
      }
      if (this.errors.length === 0) {
        divErr.classList.add("disp-none")
        this.next2();
      } 
    },

  },
};
</script>

<style>
label{
  margin-bottom: 0px !important;
  margin-top: 0.55rem !important;
}
.disp-none{
  display: none !important
}
#errores{
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
}
.required::after {
  content:" *";
  color: red;
}
.input_form_juntos{
  margin-bottom: 0.2rem !important
}
</style>